
import { makeStyles } from 'tss-react/mui';

export const useLoadingScreenStyles = makeStyles()(() => ({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
  containerFullScreen: {
    height: '100vh',
    width: '100vw',
  },
}));
